// Red61 Ticketing related code

/*
    When the website visitor selects a given performance from the calendar, the website always needs to make a call
    to VIA (via the caching wrapper) to load the detailed pricing information, which also provides ticket availability
    information for each priceband.

    If all pricebands in this performance have the seats boolean set to false, the website should update the flag in
    the performance table to be false. If any of them return true, then the website should update its flag to true in
    it’s performance table.

    This will ensure that the performance calendar then shows the current data (as seen by the wrapper’s cache, which
    might be lagging behind the live ticket availability count).

    -- https://apidocs.red61.com/7.4.0-rc1/guides/performance_sync.html
 */

import { fetchForm, setFormSubmitButtonEnabled } from "./api";
import { Analytics } from "./analytics";

$(document).ready(function () {
    const checkoutForm = document.querySelector('form[data-ticketing][name="checkout-form"]');
    const checkoutError = document.querySelector('.checkout-additional-error');
    const sendConfirmPurchase = document.querySelector('template[data-send-confirm-purchase]');

    // Checkout form
    if (checkoutForm) {
        checkoutForm.addEventListener('submit', (event) => {
            event.preventDefault();

            fetchForm(event.target).then((resp) => {
                if (resp.result && resp.redirect) {
                    window.location.href = resp.redirect;
                }
            }).catch(async (err) => {
                if (err.response) {
                    if (err.response.error) {
                        sessionStorage.setItem('PURCHASE_ERROR', err.response.error);
                        window.location.href = `/cart/purchase-unsuccessful`;

                        return;
                    }
                }

                setFormSubmitButtonEnabled(checkoutForm, true);
            });
        });
    }

    if (checkoutError) {
        const error = sessionStorage.getItem('PURCHASE_ERROR');
        if (error) {
            checkoutError.innerText = error;
            checkoutError.classList.remove('hidden');
        }
    }

    if (sendConfirmPurchase) {
        const analyticsData = window.confirmPurchaseAnalyticsData;
        Analytics.completePurchase(analyticsData.orderId, analyticsData.orderTotal, analyticsData.ticketValue, analyticsData.donationValue, analyticsData.voucherValue, analyticsData.items, analyticsData.promoCode);
    }
});